export default __webpack_public_path__ + "static/media/instructor1.9bbeca78.png";